module.exports = __webpack_public_path__ + "static/FutureofGovEd_611-101be3c303674ada47d78d3f93d089d2.png";